import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { SingleStepSportEventParticipantsFragmentDoc } from '../fragments/SingleStepSportEventParticipants.fragment';
import { MultiStepSportEventParticipantsFragmentDoc } from '../fragments/MultiStepSportEventParticipants.fragment';
import { SportEventOffersV2FragmentDoc } from '../fragments/SportEventOffersV2.fragment';
export type GetAllSportsPageV2QueryVariables = Types.Exact<{
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
	first: Types.Scalars['Int']['input'];
	bucketSize?: Types.InputMaybe<Types.Scalars['Int']['input']>;
	filter?: Types.InputMaybe<Types.SportEventFilter>;
	withOffers?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
	platform: Types.Platform;
	after?: Types.InputMaybe<Types.Scalars['String']['input']>;
	timezoneOffset: Types.Scalars['Int']['input'];
}>;

export type GetAllSportsPageV2Query = {
	__typename?: 'Query';
	sportEventBucketsV2: {
		__typename?: 'SportEventBucketsConnectionV2';
		edges?: Array<{
			__typename?: 'SportEventBucketsEdgeV2';
			key: {
				__typename?: 'SportEventAggregationKeyV2';
				sport?: { __typename?: 'Sport'; type: Types.SportType } | null;
			};
			node: {
				__typename?: 'SportEventsConnectionV2';
				edges?: Array<{
					__typename?: 'SportEventsEdgeV2';
					node:
						| {
								__typename?: 'MultiStepSportEvent';
								id: string;
								objectId: number;
								objectType: Types.ObjectType;
								sport: Types.SportType;
								offerCount: number;
								competition?: {
									__typename?: 'SportCompetitionV2';
									id: string;
									objectId: number;
									activeSeason?: { __typename?: 'SportSeason'; seasonID: number } | null;
								} | null;
								content: {
									__typename?: 'MultiStepSportEventContent';
									status: Types.SportEventStatus;
									startAt: any;
									fullPath?: string | null;
									venue?: { __typename?: 'SportVenue'; venueID: number } | null;
									competitionStage: {
										__typename?: 'SportCompetitionStageV2';
										name: Types.SportCompetitionStageName;
										number?: number | null;
									};
								};
								parent?: {
									__typename?: 'MultiStepSportEvent';
									id: string;
									content: {
										__typename?: 'MultiStepSportEventContent';
										name: string;
										fullPath?: string | null;
										startAt: any;
										status: Types.SportEventStatus;
									};
								} | null;
								watchNowOffer?: {
									__typename?: 'SportOffer';
									monetizationType: Types.MonetizationType;
									presentationType: Types.PresentationType;
									audioLanguage?: string | null;
									standardWebURL?: string | null;
									sportObjectType: Types.SportObjectType;
									package: {
										__typename?: 'Package';
										id: string;
										packageId: number;
										technicalName: string;
										clearName: string;
										shortName: string;
										monetizationTypes: Array<Types.MonetizationType>;
										iconWide: string;
									};
								} | null;
								offers?: Array<{
									__typename?: 'SportOffer';
									monetizationType: Types.MonetizationType;
									presentationType: Types.PresentationType;
									audioLanguage?: string | null;
									standardWebURL?: string | null;
									sportObjectType: Types.SportObjectType;
									package: {
										__typename?: 'Package';
										id: string;
										packageId: number;
										technicalName: string;
										clearName: string;
										shortName: string;
										monetizationTypes: Array<Types.MonetizationType>;
									};
								}>;
						  }
						| {
								__typename?: 'SingleStepSportEvent';
								id: string;
								objectId: number;
								objectType: Types.ObjectType;
								sport: Types.SportType;
								offerCount: number;
								competition?: {
									__typename?: 'SportCompetitionV2';
									id: string;
									objectId: number;
									activeSeason?: { __typename?: 'SportSeason'; seasonID: number } | null;
								} | null;
								content: {
									__typename?: 'SingleStepSportEventContent';
									status: Types.SportEventStatus;
									startAt: any;
									fullPath?: string | null;
									venue?: { __typename?: 'SportVenue'; venueID: number } | null;
								};
								competitors: {
									__typename?: 'SingleStepSportCompetitorsV2';
									homeTeam: {
										__typename?: 'SingleStepSportCompetitorV2';
										score?: number | null;
										winner: boolean;
										competitors: Array<{
											__typename?: 'SportCompetitorV2';
											id: string;
											objectId: number;
											content: {
												__typename?: 'SportCompetitorContentV2';
												name: string;
												iconUrl?: string | null;
												fullPath?: string | null;
											};
										}>;
									};
									awayTeam: {
										__typename?: 'SingleStepSportCompetitorV2';
										score?: number | null;
										winner: boolean;
										competitors: Array<{
											__typename?: 'SportCompetitorV2';
											id: string;
											objectId: number;
											content: {
												__typename?: 'SportCompetitorContentV2';
												name: string;
												iconUrl?: string | null;
												fullPath?: string | null;
											};
										}>;
									};
								};
								watchNowOffer?: {
									__typename?: 'SportOffer';
									monetizationType: Types.MonetizationType;
									presentationType: Types.PresentationType;
									audioLanguage?: string | null;
									standardWebURL?: string | null;
									sportObjectType: Types.SportObjectType;
									package: {
										__typename?: 'Package';
										id: string;
										packageId: number;
										technicalName: string;
										clearName: string;
										shortName: string;
										monetizationTypes: Array<Types.MonetizationType>;
										iconWide: string;
									};
								} | null;
								offers?: Array<{
									__typename?: 'SportOffer';
									monetizationType: Types.MonetizationType;
									presentationType: Types.PresentationType;
									audioLanguage?: string | null;
									standardWebURL?: string | null;
									sportObjectType: Types.SportObjectType;
									package: {
										__typename?: 'Package';
										id: string;
										packageId: number;
										technicalName: string;
										clearName: string;
										shortName: string;
										monetizationTypes: Array<Types.MonetizationType>;
									};
								}>;
						  };
				}> | null;
			};
		}> | null;
	};
};

export const GetAllSportsPageV2Document = gql`
	query GetAllSportsPageV2(
		$country: Country!
		$language: Language!
		$first: Int!
		$bucketSize: Int
		$filter: SportEventFilter
		$withOffers: Boolean = true
		$platform: Platform!
		$after: String
		$timezoneOffset: Int!
	) {
		sportEventBucketsV2(
			country: $country
			first: $first
			bucketSize: $bucketSize
			filter: $filter
			groupBy: SPORT
			after: $after
			timezoneOffset: $timezoneOffset
		) {
			edges {
				key {
					sport {
						type
					}
				}
				node {
					edges {
						node {
							id
							objectId
							objectType
							sport
							competition {
								id
								objectId
								activeSeason(country: $country, language: $language) {
									seasonID
								}
							}
							content(country: $country, language: $language) {
								status
								startAt
								fullPath
								venue {
									venueID
								}
							}
							...SingleStepSportEventParticipants
							...MultiStepSportEventParticipants
							...SportEventOffersV2
						}
					}
				}
			}
		}
	}
	${SingleStepSportEventParticipantsFragmentDoc}
	${MultiStepSportEventParticipantsFragmentDoc}
	${SportEventOffersV2FragmentDoc}
`;
